import { render, staticRenderFns } from "./UserEditProfile.vue?vue&type=template&id=7885322a&"
import script from "./UserEditProfile.vue?vue&type=script&lang=js&"
export * from "./UserEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7885322a')) {
      api.createRecord('7885322a', component.options)
    } else {
      api.reload('7885322a', component.options)
    }
    module.hot.accept("./UserEditProfile.vue?vue&type=template&id=7885322a&", function () {
      api.rerender('7885322a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserEditProfile.vue"
export default component.exports